import React from "react";
import useMetaTags from "../../hooks/useMetaTags"; // Adjust path based on your project structure

const HormonesMenstruationOrganicProducts = () => {
  useMetaTags({
    title: "How Hormones Affect Your Period & Why Organic Products Matter",
    description: "Learn how hormones impact your menstrual cycle and why switching to organic menstrual products can help maintain hormonal balance and overall well-being.",
    keywords: "hormones and menstruation, menstrual cycle balance, endocrine disruptors, organic pads benefits, hormone-friendly period products",
    author: "Organic Pads",
    robots: "index, follow",
    canonical: "/hormones-menstruation-organic-products",
    ogTitle: "How Hormones Affect Your Period & Why Organic Products Matter",
    ogDescription: "Understanding hormone fluctuations and avoiding endocrine disruptors in menstrual products can help you maintain a healthy balance. Learn why organic matters!",
    ogImage: "https://img.freepik.com/free-photo/communication-using-biology-document-uniform_1134-1421.jpg?ga=GA1.1.567354764.1736148549&semt=ais_hybrid",
    ogUrl: "https://organicpads.shop/hormones-menstruation-organic-products",
    ogType: "article",
    twitterCard: "summary_large_image",
    twitterTitle: "How Hormones Affect Your Period & Why Organic Products Matter",
    twitterDescription: "Discover how hormones impact your period and why switching to organic menstrual products helps maintain hormonal balance naturally.",
    twitterImage: "https://img.freepik.com/free-photo/communication-using-biology-document-uniform_1134-1421.jpg?ga=GA1.1.567354764.1736148549&semt=ais_hybrid",
    twitterSite: "@OrganicPads",
    twitterCreator: "@OrganicPads",
  });

  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "Article",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "/hormones-menstruation-organic-products"
    },
    "headline": "How Hormones Affect Your Period & Why Organic Products Matter",
    "description": "Learn how hormones impact your menstrual cycle and why switching to organic menstrual products can help maintain hormonal balance and overall well-being.",
    "image": "https://img.freepik.com/free-photo/communication-using-biology-document-uniform_1134-1421.jpg?ga=GA1.1.567354764.1736148549&semt=ais_hybrid",
    "author": {
      "@type": "Organization",
      "name": "Organic Pads",
      "url": "/"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Organic Pads",
      "logo": {
        "@type": "ImageObject",
        "url": "/logo.png"
      }
    },
    "datePublished": "2025-02-24",
    "dateModified": "2025-02-24",
    "keywords": [
      "hormones and menstruation",
      "menstrual cycle balance",
      "endocrine disruptors",
      "organic pads benefits",
      "hormone-friendly period products"
    ]
  }
  
  
  return (
    <div className="max-w-3xl mx-auto p-6 bg-white shadow-lg rounded-lg">
      <h1 className="text-3xl font-bold text-gray-900 mb-4">
        How Hormones Affect Your Period and Why Organic Products Matter
      </h1>
      <img
        src="https://img.freepik.com/free-photo/communication-using-biology-document-uniform_1134-1421.jpg?ga=GA1.1.567354764.1736148549&semt=ais_hybrid"
        alt="Hormones and Menstruation"
        className="w-full rounded-lg mb-4"
      />
      <p className="text-gray-700 mb-4">
        Understanding the relationship between hormones and menstruation can help you make better choices about menstrual products. Conventional pads containing endocrine disruptors can interfere with your natural hormone balance, making organic alternatives a healthier choice.
      </p>

      <h2 className="text-2xl font-semibold text-gray-800 mb-3">Impact of Hormones on Menstruation</h2>
      <ul className="list-disc list-inside text-gray-700 mb-4">
        <li>Natural hormone fluctuations</li>
        <li>Cycle regulation importance</li>
        <li>Endocrine system protection</li>
        <li>Chemical exposure effects</li>
        <li>Hormonal balance maintenance</li>
      </ul>

      <h2 className="text-2xl font-semibold text-gray-800 mb-3">How to Support Hormonal Health?</h2>
      <p className="text-gray-700 mb-4">
        Choose <strong>hormone-friendly</strong> products free from endocrine-disrupting chemicals. Organic pads help maintain your body's natural hormonal balance.
      </p>
      <img
        src="https://plus.unsplash.com/premium_photo-1702598576513-fe7425ebf6bd?w=600"
        alt="Natural Balance"
        className="w-full rounded-lg mb-4"
      />

      <h2 className="text-2xl font-semibold text-gray-800 mb-3">Final Thoughts</h2>
      <p className="text-gray-700 mb-4">
        Protect your hormonal health naturally. <strong>Choose organic for better balance!</strong>
      </p>
    </div>
  );
};

export default HormonesMenstruationOrganicProducts;
